import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useGame } from "@/context/GameContext";
import { Input } from "@/components/ui/input";

export default function CreateWolf() {
  const { game, refresh } = useGame();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [look, setLook] = useState("frost");
  const [busy, setBusy] = useState(false);
  if (game.wolf) return <Navigate to="/journey" replace />;
  const starters = Object.entries(game.looks).filter(([, l]) => l.starter);

  const create = async () => {
    setBusy(true);
    try {
      await api.post("/game/wolf", { name, look });
      await refresh();
      toast.success(`${name} answers the call of the wild.`);
      nav("/journey");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <main className="max-w-6xl mx-auto px-6 py-16">
      <p className="text-xs uppercase tracking-[0.3em] font-mono-game text-sky-300/80 mb-4">Chapter I · The Lone Wolf</p>
      <h1 className="font-display text-4xl sm:text-5xl text-amber-100 mb-3">Choose the wolf you will become.</h1>
      <p className="text-slate-400 mb-12">Hold a Metaland wolf or PUP? Pick any look now, then link your wallet to play as your own NFT.</p>
      <div className="grid sm:grid-cols-3 gap-5 mb-12">
        {starters.map(([id, l]) => (
          <button key={id} data-testid={`look-option-${id}`} onClick={() => setLook(id)}
            className={`group relative rounded-2xl overflow-hidden border-2 transition-all ${look === id ? "border-fuchsia-500 shadow-[0_0_30px_rgba(217,70,239,.35)]" : "border-slate-800 hover:border-slate-600"}`}>
            <img src={l.image} alt={l.name} className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" />
            <span className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/90 to-transparent font-display text-lg text-left">{l.name}</span>
          </button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 max-w-xl">
        <Input data-testid="wolf-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={20} placeholder="Name your wolf" className="h-12 bg-slate-900/80 text-lg" />
        <button data-testid="create-wolf-btn" disabled={busy || name.trim().length < 2} onClick={create} className="ember-btn px-8 h-12 rounded-lg text-sm whitespace-nowrap">AWAKEN</button>
      </div>
    </main>
  );
}
